import React, { Component } from 'react'
import {Link} from 'react-router'
import './JobSorter.scss'
import DatePicker from 'react-16-bootstrap-date-picker'
import Filters from '../Filters'
import Overview from '../Overview'
import moment from 'moment'
import {Tooltip} from 'react-tippy'
class JobSorter extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        // this._date = this._date.bind(this)
    }

    _date (type) {
      if (type === 'prevMonthStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).subtract(1, 'months').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).format('YYYY-MM-DD'))
      }
      if (type === 'nextMonthStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).add(1, 'months').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).format('YYYY-MM-DD'))
      }
      if (type === 'prevYearStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).subtract(1, 'years').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).format('YYYY-MM-DD'))
      }
      if (type === 'nextYearStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).add(1, 'years').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).format('YYYY-MM-DD'))
      }
      if (type === 'prevMonthEnd') {
        console.log(moment(new Date(this.props.endDate)).subtract(1, 'months').format('YYYY-MM-DD'))
        this.props.onStartChange(moment(new Date(this.props.startDate)).format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).subtract(1, 'months').format('YYYY-MM-DD'))
      }
      if (type === 'nextMonthEnd') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).add(1, 'months').format('YYYY-MM-DD'))
      }
      if (type === 'prevYearEnd') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).subtract(1, 'years').format('YYYY-MM-DD'))
      }
      if (type === 'nextYearEnd') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).add(1, 'years').format('YYYY-MM-DD'))
      }
    }

    _singleDate (type) {
      if (type === 'prevSingleMonthStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).subtract(1, 'months').format('YYYY-MM-DD'), moment(new Date(this.props.startDate)).format('YYYY-MM-DD'))
      }
      if (type === 'nextSingleMonthStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).add(1, 'months').format('YYYY-MM-DD'), moment(new Date(this.props.startDate)).add(2, 'months').format('YYYY-MM-DD'))
      }
      if (type === 'prevSingleYearStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).subtract(1, 'years').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).subtract(1, 'years').format('YYYY-MM-DD'))
      }
      if (type === 'nextSingleYearStart') {
        this.props.onStartChange(moment(new Date(this.props.startDate)).add(1, 'years').format('YYYY-MM-DD'), moment(new Date(this.props.endDate)).add(1, 'years').format('YYYY-MM-DD'))
      }
    }

    render() {
        return (
            <div className='job-sorter'>

              {this.props._newJob && !this.props.jobNew &&
                <div className='panel'>
                  <div className='panel-body'>
                    <div className='row  sm-col-pad'>
                    <div className='col-sm-12'>
                      <Link className='btn btn-block pull btn- btn-success' onClick={this.props._newJob.bind(null)}>
                        NEW JOB &nbsp;<i className='glyphicon glyphicon-plus' />
                      </Link>
                    </div>
                    </div>
                  </div>
                </div>
              }

              {this.props._taxReturn &&
                <div className='panel'>
                  <div className='panel-body'>
                    <div className='row  sm-col-pad'>
                    <div className='col-sm-12'>
                      <Link className='btn btn-block pull btn- btn-success' onClick={this.props._taxReturn.bind(null)}>
                        _taxReturn &nbsp;<i className='glyphicon glyphicon-plus' />
                      </Link>
                    </div>
                    </div>
                  </div>
                </div>
              }



              {this.props.monthFilter &&
                <div className='panel timeframe'>
                  <div className="half-half" style={{border: 'none', borderRadius: 5}}>
                      <div style={{background: '#fff', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                        <div className='row'>
                          <div className='col-xs-4'>
                            <button className='btn pull btn-xs btn-default btn-link' onClick={this._singleDate.bind(this, 'prevSingleMonthStart')}>
                              <i className="icon-chevron-left"></i>
                            </button>
                          </div>
                          <div className='col-xs-4 text-center'>
                            <strong>{moment(this.props.startDate).add('months', 1).format("MMM")}</strong>
                          </div>
                          <div className='col-xs-4'>
                            <button className='btn pull btn-xs btn-default btn-link' onClick={this._singleDate.bind(this, 'nextSingleMonthStart')}>
                              <i className="icon-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div style={{background: '#fff', borderTopRightRadius: 5, borderBottomRightRadius: 5}}>
                        <div className='row'>
                          <div className='col-xs-4'>
                            <button className='btn pull btn-xs btn-default btn-link' onClick={this._singleDate.bind(this, 'prevSingleYearStart')}>
                              <i className="icon-chevron-left"></i>
                            </button>
                          </div>
                          <div className='col-xs-4 text-center'>
                            <strong>{moment(this.props.startDate).format("YYYY")}</strong>
                          </div>
                          <div className='col-xs-4'>
                            <button className='btn pull btn-xs btn-default btn-link' onClick={this._singleDate.bind(this, 'nextSingleYearStart')}>
                              <i className="icon-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              }

              {this.props.startDate && !this.props.monthFilter &&
                <div className='row timeframe'>
                  <div className='col-xs-2'>
                  <div className='labels'>
                  <br/>
                    Start:
                    <br/><br/>
                    End:
                  </div>
                  </div>
                  <div className='col-xs-10'>
                    <div className='panel'>
                      <div className="half-half" style={{border: 'none', borderRadius: 5}}>
                          <div style={{background: '#fff', borderTopLeftRadius: 0}}>
                            <div className='row'>
                              <div className='col-xs-3'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'prevMonthStart')}>
                                  <i className="icon-chevron-left"></i>
                                </button>
                              </div>
                              <div className='col-xs-6 text-center'>
                                <strong>{moment(this.props.startDate).format("MMM")}</strong>
                              </div>
                              <div className='col-xs-3'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'nextMonthStart')}>
                                  <i className="icon-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div style={{background: '#fff', borderTopRightRadius: 5}}>
                            <div className='row'>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'prevYearStart')}>
                                  <i className="icon-chevron-left"></i>
                                </button>
                              </div>
                              <div className='col-xs-4 text-center'>
                                <strong>{moment(this.props.startDate).format("YYYY")}</strong>
                              </div>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'nextYearStart')}>
                                  <i className="icon-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div className="half-half">
                          <div style={{background: '#fff', borderBottomLeftRadius: 0}}>
                            <div className='row'>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'prevMonthEnd')}>
                                  <i className="icon-chevron-left"></i>
                                </button>
                              </div>
                              <div className='col-xs-4 text-center'>
                                <strong>{moment(this.props.endDate).format("MMM")}</strong>
                              </div>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'nextMonthEnd')}>
                                  <i className="icon-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div style={{background: '#fff', borderBottomRightRadius: 5}}>
                            <div className='row'>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'prevYearEnd')}>
                                  <i className="icon-chevron-left"></i>
                                </button>
                              </div>
                              <div className='col-xs-4 text-center'>
                                <strong>{moment(this.props.endDate).format("YYYY")}</strong>
                              </div>
                              <div className='col-xs-4'>
                                <button className='btn pull btn-xs btn-default btn-link' onClick={this._date.bind(this, 'nextYearEnd')}>
                                  <i className="icon-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <Overview
                profit={this.props.profit}
                cost={this.props.cost}
                sale={this.props.sale}
              />






              {this.props.showFilter &&
                <div className='panel'>
                  <div className='panel-heading'>
                    Job Filters
                  </div>
                  {this.props._newJob &&
                    <div className='panel-body'>
                      {this.props.view === 'carousels' &&
                        <Tooltip title="Quickly change the status of your jobs" position="top" trigger="mouseenter">
                          <button onClick={this.props._view.bind(null, 'board')} type="button" className={`btn btn-block  btn-info`}>
                            <i className="icon-grid"></i> Edit Job Statuses
                          </button>
                        </Tooltip>
                      }
                      {this.props.view === 'board' &&
                        <button onClick={this.props._view.bind(null, 'carousels')} type="button" className={`btn btn-block  btn-danger`}>
                          <i className="icon-arrow-left"></i> Finished Editing
                        </button>
                      }
                    </div>
                  }

                  <div className="panel-footer">
                    <Filters _filter={this.props._filter.bind(this)} filter={this.props.filter} />
                  </div>
                </div>
              }



            </div>
        )
    }
}

export default JobSorter;



// WEBPACK FOOTER //
// ./src/views/components/JobSorter/index.js